import { render } from "./async-route.vue?vue&type=template&id=4aa3b885"
import script from "./async-route.vue?vue&type=script&lang=js"
export * from "./async-route.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./async-route.vue?vue&type=custom&index=0&blockType=i18n&lang=json5"
if (typeof block0 === 'function') block0(script)
import block1 from "./async-route.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/ubuntu/odk/odk-ssdd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__